import { createStand } from '##/stand/standConfig';

export default createStand({
  title: 'Быстрый старт',
  id: 'start',
  group: 'about',
  order: 13,
});
